export const DROPDOWN_CONFIG = {
  DEFAULT_MAX_WIDTH: 250,
  MIN_WIDTH: 120,
  PREFERRED_WIDTH: 160,
  CONSTRAINED_MAX_WIDTH: 230,
  COLUMN_PADDING: 10,
  VIEWPORT_MARGIN: 10,
  TOP_OFFSET: 5,
  Z_INDEX_VISIBLE: 10000,
  Z_INDEX_HIDDEN: 1,
  PADDING: 16,
  HEADER_MARGIN_TOP: 12,
  OPTION_MARGIN_BOTTOM: 8,
};

export const SELECTORS = {
  TABLE_CONTAINERS: ".license-management-table, .ag-root-wrapper",
  SCROLL_CONTAINERS: ".ag-body-viewport, .ag-header-viewport, .license-management-table, .ag-root-wrapper",
  HEADER_CELL: ".ag-header-cell",
  LEFT_PINNED:
    ".ag-header-cell-pinned-left, .ag-pinned-left-header, .ag-pinned-left-cols-container, [class*='ag-pinned-left'], [class*='pinned-left']",
  RIGHT_PINNED:
    ".ag-header-cell-pinned-right, .ag-pinned-right-header, .ag-pinned-right-cols-container, [class*='ag-pinned-right'], [class*='pinned-right']",
  PORTAL_DROPDOWN: ".license-portal-dropdown-content",
};
